function siteKey() {
  return document.querySelector('meta[name="recaptcha-site-key"]')?.content || ""
}

function executeRecaptcha(action) {
  const key = siteKey()
  if (!key || !window.grecaptcha?.execute) {
    return Promise.resolve("")
  }

  return new Promise((resolve, reject) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(key, { action: action || "submit" })
        .then(resolve)
        .catch(reject)
    })
  })
}

function bindNavToggle() {
  const header = document.querySelector(".site-header")
  const toggle = document.querySelector("[data-nav-toggle]")
  if (!header || !toggle || toggle.dataset.bound === "true") return
  toggle.dataset.bound = "true"
  toggle.addEventListener("click", () => {
    const open = header.classList.toggle("is-open")
    toggle.setAttribute("aria-expanded", open ? "true" : "false")
  })
}

function bindListenScroll() {
  if (document.documentElement.dataset.listenScrollBound === "true") return
  document.documentElement.dataset.listenScrollBound = "true"

  document.addEventListener("click", (e) => {
    const link = e.target.closest("[data-listen-scroll]")
    if (!link) return
    const target = document.querySelector("#archive-player")
    if (!target) return
    e.preventDefault()
    target.scrollIntoView({ behavior: "smooth", block: "start" })
  })
}

function bindHomeHero() {
  const copy = document.querySelector("[data-hero-copy]")
  if (copy) {
    requestAnimationFrame(() => copy.classList.add("is-ready"))
  }

  const stage = document.querySelector("[data-hero-stage]")
  const pauseBtn = document.querySelector("[data-hero-pause]")
  if (!stage || !pauseBtn || pauseBtn.dataset.bound === "true") return
  pauseBtn.dataset.bound = "true"

  const label = pauseBtn.querySelector("[data-hero-pause-label]")
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
  if (reduceMotion) {
    stage.classList.add("is-paused")
    pauseBtn.hidden = true
    return
  }

  const setPaused = (paused) => {
    stage.classList.toggle("is-paused", paused)
    pauseBtn.setAttribute("aria-pressed", paused ? "true" : "false")
    pauseBtn.setAttribute("aria-label", paused ? "Play card motion" : "Pause card motion")
    if (label) label.textContent = paused ? "Play" : "Pause"
  }

  pauseBtn.addEventListener("click", () => {
    setPaused(!stage.classList.contains("is-paused"))
  })
}

function bindNewsletterForms() {
  document.querySelectorAll("[data-newsletter-form]").forEach((form) => {
    if (form.dataset.bound === "true") return
    form.dataset.bound = "true"

    form.addEventListener("submit", async (e) => {
      e.preventDefault()
      const status = form.querySelector("[data-newsletter-status]")
      const submit = form.querySelector('button[type="submit"]')
      const action = form.dataset.recaptchaAction || "newsletter"

      if (submit) {
        submit.disabled = true
        submit.textContent = "…"
      }

      try {
        const token = await executeRecaptcha(action)
        const data = new FormData(form)
        if (token) data.set("g-recaptcha-response", token)

        const res = await fetch(form.action, {
          method: "POST",
          headers: {
            Accept: "application/json",
          },
          body: data,
        })
        const json = await res.json().catch(() => ({}))
        if (status) {
          status.hidden = false
          status.textContent = json.message || json.error || (res.ok ? "You have Successfully Subscribed!" : "Something went wrong.")
        }
        if (res.ok) form.reset()
      } catch (_err) {
        if (status) {
          status.hidden = false
          status.textContent = "Network error — please try again."
        }
      } finally {
        if (submit) {
          submit.disabled = false
          submit.textContent = "Submit"
        }
      }
    })
  })
}

function bindContactForm() {
  const form = document.querySelector("[data-contact-form]")
  if (!form || form.dataset.bound === "true") return
  form.dataset.bound = "true"

  form.addEventListener("submit", async (e) => {
    if (form.dataset.recaptchaDone === "true") return
    e.preventDefault()

    const submit = form.querySelector('input[type="submit"], button[type="submit"]')
    if (submit) submit.disabled = true

    try {
      const token = await executeRecaptcha(form.dataset.recaptchaAction || "contact")
      const field = form.querySelector("[data-recaptcha-response]")
      if (field) field.value = token || ""
      form.dataset.recaptchaDone = "true"
      form.requestSubmit ? form.requestSubmit() : form.submit()
    } catch (_err) {
      if (submit) submit.disabled = false
      alert("Spam check failed to load. Please refresh and try again.")
    }
  })
}

function bindNewsletterPopup() {
  const popup = document.querySelector("[data-newsletter-popup]")
  if (!popup || popup.dataset.bound === "true") return
  popup.dataset.bound = "true"

  const key = "mcto_newsletter_popup_seen"
  const close = () => {
    popup.hidden = true
    localStorage.setItem(key, "1")
  }

  popup.querySelector("[data-popup-close]")?.addEventListener("click", close)
  popup.addEventListener("click", (e) => {
    if (e.target === popup) close()
  })

  if (!localStorage.getItem(key)) {
    window.setTimeout(() => {
      popup.hidden = false
    }, 12000)
  }
}

function bindCalendlyPopups() {
  if (document.documentElement.dataset.calendlyBound === "true") return
  document.documentElement.dataset.calendlyBound = "true"

  document.addEventListener("click", (e) => {
    const link = e.target.closest("[data-calendly-popup]")
    if (!link) return
    e.preventDefault()
    const url = link.getAttribute("data-calendly-popup") || link.href
    if (window.Calendly?.showPopupWidget) {
      window.Calendly.showPopupWidget(url)
    } else {
      window.open(url, "_blank", "noopener")
    }
  })
}

function bindEpisodePagination() {
  if (document.documentElement.dataset.episodePaginationBound === "true") return
  document.documentElement.dataset.episodePaginationBound = "true"

  document.addEventListener("click", (e) => {
    const link = e.target.closest("[data-episode-index] .pagination a")
    if (!link) return
    e.preventDefault()
    loadEpisodeIndexPage(link.href, { push: true })
  })

  window.addEventListener("popstate", () => {
    if (!document.querySelector("[data-episode-index]")) return
    loadEpisodeIndexPage(window.location.href, { push: false })
  })
}

async function loadEpisodeIndexPage(url, { push }) {
  const root = document.querySelector("[data-episode-index]")
  if (!root) return

  root.setAttribute("aria-busy", "true")
  root.classList.add("is-loading")

  try {
    const res = await fetch(url, {
      headers: {
        Accept: "text/html",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
    if (!res.ok) {
      window.location.href = url
      return
    }

    const html = await res.text()
    const doc = new DOMParser().parseFromString(html, "text/html")
    const next = doc.querySelector("[data-episode-index]")
    if (!next) {
      window.location.href = url
      return
    }

    root.replaceWith(next)
    document.title = doc.title
    if (push) {
      history.pushState({ episodeIndex: true }, "", url)
    }
    next.scrollIntoView({ behavior: "smooth", block: "start" })
  } catch (_err) {
    window.location.href = url
  }
}

document.addEventListener("DOMContentLoaded", () => {
  bindNavToggle()
  bindListenScroll()
  bindHomeHero()
  bindNewsletterForms()
  bindContactForm()
  bindNewsletterPopup()
  bindCalendlyPopups()
  bindEpisodePagination()
})
